import { PayablesService_payablesServiceGetDetails } from '@festina/moneyout-general-types/moneyout/hooks/PayablesService_payablesServiceGetDetails'

export const useFetchPayablesDetails =
  PayablesService_payablesServiceGetDetails.useSuspenseQuery
